module.exports = __webpack_public_path__ + "img/no-items-search.957a46c2.svg";